<template>
  <div class="whole-analysis" :style="style">
    <template v-if="ready">
      <template>
        <div
          v-if="!insideMode"
          class="add-scene-button"
          @click="onClickAddScene"
        >
          添加到常用场景
        </div>
        <user-group-bar
          v-model="userGroup"
          class="analysis-whole-user-group"
          :max="maxGroup"
          @clickOk="onQuery"
        ></user-group-bar>
        <plat-bar v-model="modulePlat" @change="onPlatChange"></plat-bar>
        <whole-condition
          v-model="conditions"
          @onClickSearch="onClickSearch"
          @changeTarget="onChangeTarget"
          @change="onChangeCondition"
          @biz-create-warning="bizCreateWarning"
          ref="condition"
        ></whole-condition>
        <div class="chart-panel">
          <div class="chart-top">
            <biz-date-picker
              v-model="queryDate"
              :showToday="false"
              :hourAble="hourAble"
              :monthLimit="dateMonthLimit"
              :includeToday="isRealTime"
              @change="onChangeDate"
            ></biz-date-picker>
            <c-selector
              :store="chartTypeList"
              :disableOptions="disableCharTypes"
              class="type-list"
              v-model="chartType"
              @change="onQuery"
              :width="107"
              keyField="value"
              labelField="label"
              iconField="icon"
            >
              <template slot-scope="{ data }">
                <template v-if="disableCharTypes.includes(data.value)">
                  <c-tooltip
                    :content="
                      data.value === 'map'
                        ? '只适用于城市/省份细分'
                        : '只适用于属性细分'
                    "
                    placeholder="top-left"
                  >
                    <i :class="data.icon" style="margin-right: 5px"></i
                    >{{ data.label }}
                  </c-tooltip>
                </template>
                <template v-else>
                  <i :class="data.icon" style="margin-right: 5px"></i
                  >{{ data.label }}
                </template>
              </template>
            </c-selector>
            <c-button
              v-if="!insideMode"
              size="normal"
              class="btn-board"
              icon="icon-kanban"
              @click="toAddBoard"
            >
              添加到看板
            </c-button>
          </div>
          <div v-if="!isSaaS && !loading" class="chart-title">
            <update-time
              :platId="modulePlat"
              :dimensionConditions="conditions.dimensionSub"
              :filterConditions="conditions.conditions"
              :isRealTime="isRealTime"
            ></update-time>
          </div>
          <div v-if="loading" style="height: 400px;z-index: 10">
            <c-loading></c-loading>
          </div>
          <whole-chart
            v-if="!loading"
            :query-param="queryParam"
            :show-list="selected"
            :char-type="chartType.value"
            :target="conditions.target"
            :store="resData"
          ></whole-chart>
        </div>
        <whole-grid
          v-if="!loading"
          :meta-data="resData"
          :queryParam="queryParam"
          :dimension="
            conditions.dimensionSub ? conditions.dimensionSub.label : null
          "
          :target="conditions.target"
          :lastSelected="selected"
          @detail="onDetail"
          @select="onSelectRow"
        ></whole-grid>
      </template>
    </template>
    <c-loading v-else></c-loading>
  </div>
</template>

<script>
import UserGroupBar from '../../components/groupBar'
import WholeCondition from './condition'
import { actions } from '../../store/constants'
import routes from '../../routes'
import { mapState } from 'vuex'
import WholeGrid from './grid'
import WholeChart from './chart'
import { util, base64 } from '../../utils'
import { storageKey, versionCode } from '../../constants'
import PlatBar from '../../components/cross/platBar'
import updateTime from '../../components/chartUpdateTime/updateTime.vue'
export default {
  name: 'bizAnalysisWhole',
  components: {
    PlatBar,
    updateTime,
    WholeChart,
    WholeGrid,
    WholeCondition,
    UserGroupBar
  },
  props: {
    /**
     * @description 内嵌模式
     */
    insideMode: {
      type: Boolean,
      default: false
    },
    /**
     * @description 通过看板页面添加指标打开时，需要传递当前看板，以便于添加看板弹窗能默认选中看板
     */
    currentPanel: {
      type: Object,
      default () {
        return {
          id: null
        }
      }
    },
    initialQueryParam: null
  },
  data () {
    let data = {
      userGroup: [{ id: 0 }],
      loading: true,
      conditions: {
        target: { name: '新增用户', value: 'add' },
        dimensionSub: null,
        conditions: null
      },
      chartType: { value: 'line' },
      resData: {
        series: [],
        x_axis: []
      },
      selected: [],
      queryDate: null,
      showDetailFrame: false,
      cancelToken: null,
      queryTimeout: null,
      hourAble: true,
      modulePlat: 0
    }
    if (!this.insideMode) {
      let queryParam = this.$route.query
      if (queryParam && JSON.stringify(queryParam) !== '{}') {
        data.chartType.value = queryParam.graph
        data.queryDate = {
          dateType: queryParam.range.split(',')[2],
          params: queryParam.range.split(',').splice(0, 2),
          unit: queryParam.seg
        }
        // 内部平台 = 路由参数
        data.modulePlat = queryParam.p
        if (queryParam.module) {
          data.conditions.target = {
            value: queryParam.module
          }
        }
        if (queryParam.g) {
          if (/,/.test(queryParam.g)) {
            data.conditions.dimensionSub = {
              value: queryParam.g.split(',')[1],
              category: 'custom',
              dimension_sub: queryParam.g.split(',')[0],
              dimensionId: queryParam.g // 细分属性唯一值dimensionId（prop.dimension_sub, prop.value）
            }
          } else {
            data.conditions.dimensionSub = {
              value: queryParam.g,
              dimensionId: [queryParam.g, queryParam.g].join(',') // 内置属性dimension_sub === value
            }
          }
        }
        if (queryParam.cohorts) {
          data.userGroup = queryParam.cohorts.split(',').map(id => {
            return {
              id: parseInt(id)
            }
          })
        }
        if (queryParam.filter) {
          data.conditions.conditions = JSON.parse(queryParam.filter)
        }
      }
    } else if (this.initialQueryParam) {
      let queryParam = this.initialQueryParam.data
      data.chartType.value = queryParam.chartType.split(',')[0]
      let time = this.$util.isString(queryParam.time)
        ? JSON.parse(queryParam.time)
        : queryParam.time
      let unit = time.dimension_date.split(',')[0]
      data.queryDate = {
        dateType: this.initialQueryParam.timeRangeType,
        params: [time.begin_date, time.end_date],
        unit: unit !== 'total' ? unit : 'day'
      }
      // 内部平台 = 指标参数
      data.modulePlat = queryParam.platform
      let target = queryParam.module
      if (target === 'active' && queryParam.analysis_index === 'times') {
        target = 'pv'
      }
      data.conditions.target = {
        value: target
      }
      if (queryParam.dimension_sub) {
        if (queryParam.user_attr) {
          data.conditions.dimensionSub = {
            value: queryParam.user_attr,
            dimension_sub: 'user_attr',
            category: 'custom',
            dimensionId: ['user_attr', queryParam.user_attr].join(',')
          }
        } else {
          data.conditions.dimensionSub = {
            value: queryParam.dimension_sub,
            dimensionId: [
              queryParam.dimension_sub,
              queryParam.dimension_sub
            ].join(',')
          }
        }
      }
      if (queryParam.user_group) {
        data.userGroup = queryParam.user_group.split(',').map(id => {
          return {
            id: parseInt(id)
          }
        })
      }
      if (queryParam.filter_condition) {
        data.conditions.conditions = JSON.parse(queryParam.filter_condition)
      }
    }
    return data
  },
  computed: {
    ...mapState({
      ready (state) {
        return (
          state.bizUserGroup.ready.list &&
          state.bizSys.ready.eventEnvs &&
          state.bizSys.ready.userProps &&
          state.bizSys.ready.eventGroups
        )
      },
      currentUser (state) {
        return state.bizSys.currentUser || {}
      },
      userGroupList (state) {
        return state.userGroup.list
      }
    }),
    style () {
      return {
        padding: this.showDetailFrame || this.insideMode ? 0 : '30px'
      }
    },
    isRealTime () {
      let target = this.conditions.target
      return ![target.value].includes('add', 'duration_avg', 'duration')
    },
    dateMonthLimit () {
      let monthLimit = 3
      let version = this.currentUser.version
      if (
        version === versionCode.pro ||
        version === versionCode.ep
      ) {
        monthLimit = 12
      }
      return monthLimit
    },
    maxGroup () {
      let count = 3
      if (this.conditions && this.conditions.target.value === 'duration') { count = 1 }
      return count
    },
    chartTypeList () {
      let list = [
        { label: '趋势图', value: 'line', icon: 'icon-funnel-line' },
        { label: '汇总图', value: 'bar', icon: 'icon-analysis' },
        { label: '占比图', value: 'pie', icon: 'icon-pie' },
        { label: '地图', value: 'map', icon: 'icon-zhongguoditu' }
      ]
      return list
    },
    disableCharTypes () {
      let list = []
      if (this.conditions) {
        let target = this.conditions.target.value
        if (target === 'duration') {
          list.push('line')
        } else if (!this.conditions.dimensionSub) {
          list.push('pie')
        }
      }
      if (!this.mapAble) {
        list.push('map')
      }
      return list
    },
    haveUserGroup () {
      let exist = false
      this.userGroup.forEach(group => {
        if (group.id !== 0) exist = true
      })
      return exist
    },
    baseParams () {
      return {
        appId: this.appId,
        platform: this.modulePlat
      }
    },
    queryParam () {
      let module = this.conditions.target.value
      let analysisIndex = null
      switch (this.conditions.target.value) {
        case 'pv':
          module = 'active'
          analysisIndex = 'times'
          break
        case 'add':
        case 'active':
          analysisIndex = 'number'
          break
        case 'duration_avg':
          analysisIndex = null
          break
        case 'duration':
          analysisIndex = 'number,times'
          break
        default:
          console.error('错误的指标类型', this.conditions.target.value)
      }
      if (this.conditions.conditions && this.queryDate) {
        this.conditions.conditions.eventCondition.eventSingleConditions.forEach(
          item => {
            item.happenTime.params = [
              this.queryDate.dateType,
              ...this.queryDate.params,
              this.queryDate.unit
            ]
          }
        )
      }
      let queryParam = {
        app_id: this.baseParams.appId,
        platform: this.baseParams.platform,
        user_group: this.userGroup.map(item => item.id).join(','),
        filter_condition: JSON.stringify(this.conditions.conditions),
        analysis_index: analysisIndex,
        dimension_sub: this.conditions.dimensionSub
          ? this.conditions.dimensionSub.value
          : null,
        module,
        chartType: this.chartType.value
      }
      if (this.queryDate) {
        queryParam.time = JSON.stringify({
          dimension_date:
            this.chartType.value === 'line' ? this.queryDate.unit : 'total',
          begin_date: this.queryDate.absoluteValue[0],
          end_date: this.queryDate.absoluteValue[1]
        })
      }
      let dimension = this.conditions.dimensionSub
      if (dimension && dimension.category === 'custom') {
        queryParam.dimension_sub = dimension.dimension_sub
        queryParam[dimension.dimension_sub] = dimension.value
      }
      return queryParam
    },
    mapAble () {
      let result = false
      if (
        this.conditions &&
        this.conditions.dimensionSub &&
        this.conditions.target
      ) {
        let dimension = this.conditions.dimensionSub
        let target = this.conditions.target
        let analysisIndex = ''
        switch (target.value) {
          case 'pv':
            analysisIndex = 'times'
            break
          case 'add':
          case 'active':
            analysisIndex = 'number'
            break
          case 'duration_avg':
            analysisIndex = null
            break
          case 'duration':
            analysisIndex = 'number,times'
            break
          default:
            console.error('错误的指标类型', target.value)
        }
        result = this.isMap(dimension.value, analysisIndex)
      }
      return result
    },
    haveGroup () {
      return this.userGroup.length > 1 || this.userGroup[0].id !== 0
    },
    targetParam () {
      let data = this.$util.clone(this.queryParam)
      data.time = JSON.parse(data.time)
      if (this.queryDate.dateType === 'relative') {
        data.time.begin_date = this.queryDate.params[0]
        data.time.end_date = this.queryDate.params[1]
        if (/total/.test(data.time.dimension_date)) { data.time.dimension_date = `${this.queryDate.unit},total` }
      }
      data.time = JSON.stringify(data.time)
      let param = {
        chosen_data: !this.loading ? this.selected : null, // chartData数据没查询结束时无chosen_data
        data,
        timeRangeType: this.queryDate.dateType
      }
      return param
    },
    detailParam () {
      let queryParam = this.queryParam
      let groupBy =
        this.chartType.value === 'line' ? this.queryDate.unit : 'total'
      let param = {
        appid: queryParam.app_id,
        plat: queryParam.platform,
        module: queryParam.module,
        begin_date: this.queryDate.absoluteValue[0].replace(/-/g, ''),
        end_date: this.queryDate.absoluteValue[1].replace(/-/g, ''),
        group_by: queryParam.module === 'duration' ? '' : groupBy,
        add_group: false,
        user_group_id: queryParam.user_group,
        group_condition: queryParam.filter_condition,
        isTotal: JSON.parse(queryParam.time).dimension_date === 'total',
        user_type: 0,
        data_type: 'new'
      }
      if (queryParam.dimension_sub) {
        param.group_by = [
          this.queryDate.unit,
          queryParam.user_attr || queryParam.dimension_sub
        ].join(',')
      }
      if (queryParam.module === 'add') {
        param.data_type = 'new'
      } else if (queryParam.module === 'active') {
        param.data_type = 'active'
      } else {
        param.data_type = 'duration'
      }
      return param
    },
    sceneTargetParam () {
      return util.clone(this.targetParam)
    }
  },
  watch: {
    appId () {
      this.reset()
      this.onQuery()
    },
    chartType (type, preType) {
      if (preType && preType.label) {
        window.track('整体-切换图表样式', {
          图表样式: type.label
        })
      }
    }
  },
  mounted () {
    window.track('整体-进入模块', {
      位置: this.$route.name === routes.panel ? '看板' : '分析'
    })
    // 还原缓存状态
    sessionStorage.removeItem(storageKey.queryParamCacheStr)
    // 基础数据：用户群、触发环境、用户属性、事件列表
    this.$store.dispatch(actions.userGroup.query)
    this.$store.dispatch(actions.biz.sys.queryEventMeta, {
      force: false,
      appId: this.appId,
      platform: this.platform
    }).catch(error => {
      if (error.__CANCEL__) return
      console.error(error)
    })
    let params = {
      appId: this.appId,
      platform: this.platform
    }
    this.$store.dispatch(actions.biz.sys.queryEnvMeta, params).catch(error => {
      if (error.__CANCEL__) return
      console.error(error)
    })
    this.$store
      .dispatch(actions.biz.sys.queryUserProps, params)
      .catch(error => {
        if (error.__CANCEL__) return
        console.error(error)
      })
  },
  methods: {
    reset () {
      this.replaceRouter({
        name: this.$route.name,
        query: ''
      })
      this.userGroup = [{ id: '0' }]
      this.conditions = {
        target: { name: '新增用户', value: 'add' },
        conditions: null,
        dimensionSub: null
      }
      this.chartType = { value: 'line' }
      this.resData = {
        series: [],
        x_axis: []
      }
      this.selected = []
      this.queryDate = null
      this.showDetailFrame = false
      this.hourAble = true
      this.modulePlat = 0
    },
    mapAutoUpdate () {
      if (this.mapAble && this.chartType.value !== 'map') {
        this.chartType = {
          value: 'map'
        }
      }
      if (!this.mapAble && this.chartType.value === 'map') {
        let type = 'line'
        if (this.conditions && this.conditions.target) {
          if (this.conditions.target.value === 'duration') {
            type = 'bar'
          }
        }
        this.chartType = {
          value: type
        }
      }
    },
    onClickSearch () {
      this.mapAutoUpdate()
    },
    onChangeTarget () {
      this.mapAutoUpdate()
    },
    onChangeCondition () {
      if (this.conditions.target.value === 'duration') {
        this.chartType = { value: 'bar' }
      }
      // 如果没有选择属性细分，并且图表类型是占比图，则需要置为趋势图
      if (!this.conditions.dimensionSub && this.chartType.value === 'pie') {
        this.chartType = { value: 'line' }
      }
      if (['duration_avg', 'duration'].includes(this.conditions.target.value)) {
        this.hourAble = false
      } else {
        this.hourAble = true
      }
      this.$nextTick(() => {
        this.onQuery()
      })
    },
    onChangeDate () {
      this.onQuery()
    },
    onQuery () {
      if (!this.queryDate) return
      this.loading = true
      if (!this.insideMode) this.changeUrl()
      this.$emit('queryDataBefore')
      const queryParam = util.clone(this.queryParam)
      queryParam.unique = true
      this.$store
        .dispatch(actions.analysis.queryData, queryParam)
        .then(data => {
          this.$emit('queryDataAfter')
          this.loading = false
          this.sortData(data)
          this.resData = data
        })
        .catch(error => {
          if (error.__CANCEL__) return
          this.$message({
            type: 'error',
            message: '查询数据失败'
          })
          console.error('查询整体数据失败', error)
        })
        .finally(() => {
          this.$refs.condition.setPreOutput()
        })
    },
    sortData (data) {
      util.sortData(this.queryParam, data)
    },
    changeUrl () {
      let queryParam = {
        range: [...this.queryDate.params, this.queryDate.dateType].join(','),
        graph: this.chartType.value,
        seg: this.queryDate.unit,
        app_id: this.baseParams.appId,
        p: this.baseParams.platform,
        module: this.conditions.target.value,
        m: this.queryParam.analysis_index
      }
      let dimension = this.conditions.dimensionSub
      if (dimension) {
        if (dimension.category === 'custom') {
          queryParam.g = `${dimension.dimension_sub},${dimension.value}`
        } else {
          queryParam.g = dimension.value
        }
      }
      if (this.userGroup.length > 1 || this.userGroup[0].id !== 0) {
        queryParam.cohorts = this.userGroup.map(group => group.id).join(',')
      }
      if (this.conditions.exist) {
        queryParam.filter = this.queryParam.filter_condition
      }
      this.replaceRouter({
        name: this.$route.name,
        query: queryParam
      })
    },
    toAddBoard (defaultObj) {
      let data = {}
      if (defaultObj) {
        data['editMode'] = defaultObj.editMode || 'new'
        data['defaultId'] = defaultObj.elementId || 0
        data ['defaultName'] = defaultObj.elementName || this.conditions.target.name || ''
      }
      this.$emit('bizAddBoard', data)
      window.track('整体-添加到看板')
    },
    onSelectRow (selected) {
      this.selected = selected.map(item => item.names)
    },
    onDetail (data, field) {
      let queryParam = this.$util.clone(this.detailParam)
      if (['add', 'active'].includes(queryParam.module)) {
        if (field.split('|').length > 1) {
          queryParam.begin_date = field
            .split('|')[0]
            .replace(/[-:\s]/g, '')
            .replace('0000', '')
          queryParam.end_date = field
            .split('|')[1]
            .replace(/[-:\s]/g, '')
            .replace('0000', '')
        } else {
          queryParam.end_date = queryParam.begin_date = field
            .replace(/[-:\s]/g, '')
            .replace('0000', '')
        }
        if (this.conditions.dimensionSub) {
          let value = data.target
          if (['未知', '直接访问'].includes(value)) value = '-'
          queryParam.group_value = value
        } else {
          queryParam.group_value = ''
        }
      } else if (queryParam.module === 'duration') {
        queryParam.group_by = ''
        queryParam.group_value = field
      }
      if (this.haveUserGroup) {
        let userGroupId = 0
        this.userGroupList.forEach(group => {
          if (group.name === data.userGroup) {
            userGroupId = group.id
          }
        })
        queryParam.user_group_id = userGroupId // 需要把用户群名称转为id
      }
      let param = {
        count: data[field],
        appId: this.baseParams.appId,
        platform: this.baseParams.platform,
        url:
          '/data/appEventBatch.jsp?' + base64.encode(JSON.stringify(queryParam))
      }
      let _ = []
      for (let key in param) {
        _.push(`${key}=${param[key]}`)
      }
      // this.showDetailFrame = true
      this.$emit('bizShowUserInfo', _)
    },
    onPlatChange (id) {
      this.modulePlat = id
      this.onQuery()
    },
    onClickAddScene () {
      this.$emit('bizAddScene')
      window.track('常用场景-添加', {
        来源: '整体'
      })
    },
    bizCreateWarning() {
      this.$emit('bizCreateWarning')
      window.track('整体-创建预警')
    }
  }
}
</script>

<style lang="sass">
@import "styles/index"
</style>
